export default "__VITE_ASSET__C3SBUT23__"